import './_quick-shop-product-info.scss';

export default () => {};
